import React from 'react';
export function CompleteSystemOffer() {
  return <div className="max-w-4xl mx-auto mb-8 text-center" data-id="element-188">
      <h2 className="text-2xl md:text-4xl font-bold text-black mb-8" data-id="element-189">
        Hoy puedes acceder al sistema completo
      </h2>
      {/* Visual representation of the full stack */}
      <div className="mb-8 flex justify-center" data-id="element-190">
        <img src="https://cdn.magicpatterns.com/uploads/tZ5HNHL7yceUkm8W1gJPub/Screenshot_2026-01-08_at_11.02.51_PM.png" alt="Complete Bootcamp System with all modules and bonuses" className="w-full max-w-4xl h-auto object-contain" data-id="element-191" />
      </div>
      <div className="mt-12" data-id="element-192">
        <div className="relative inline-block" data-id="element-193">
          <span className="text-3xl md:text-5xl font-bold text-red-500 line-through decoration-4 decoration-red-500 opacity-80" data-id="element-194">
            $3,970 valor regular
          </span>
        </div>
        <div className="flex items-center justify-center gap-3 mt-4" data-id="element-195">
          <span className="text-3xl md:text-5xl font-bold text-black" data-id="element-196">
            Solo por
          </span>
          <span className="text-5xl md:text-7xl font-black text-[#06b6d4]" data-id="element-197">
            $297
          </span>
        </div>
      </div>
    </div>;
}